var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    {
      class: { "pt-0": _vm.currentUser.clientType === "Media" },
      attrs: { "data-testid": "home", fluid: "" },
    },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "pb-0 px-2", attrs: { cols: "12" } },
            [
              _c("div", { staticClass: "mb-2" }, [
                _c(
                  "h2",
                  {
                    staticClass: "text-uppercase font-weight-bold",
                    staticStyle: { "font-size": "16px" },
                    attrs: { "data-testid": "home-header" },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        `${_vm.currentUser.clientName} · ${_vm.$t(
                          "homeStats.data"
                        )}`
                      )
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _vm.$vuetify.breakpoint.mdAndUp
                ? _c(
                    "div",
                    {
                      staticClass: "d-flex mb-2",
                      staticStyle: {
                        gap: "11px",
                        width: "100%",
                        "flex-wrap": "wrap",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { flex: "1 1 0", "min-width": "0" } },
                        [
                          _c(
                            "v-card",
                            {
                              staticClass: "stats-card d-flex flex-column",
                              staticStyle: {
                                "border-radius": "8px",
                                height: "100%",
                              },
                              attrs: {
                                "data-testid": "home-card-players",
                                elevation: "0",
                                outlined: "",
                              },
                            },
                            [
                              _vm.loading || !_vm.driblabStats
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "pa-4 d-flex flex-column",
                                      staticStyle: { height: "100%" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-space-between align-start mb-4",
                                        },
                                        [
                                          _c("v-skeleton-loader", {
                                            attrs: {
                                              type: "text",
                                              width: "40%",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("v-skeleton-loader", {
                                            staticClass: "ma-0",
                                            attrs: {
                                              type: "avatar",
                                              size: "28",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "mb-4",
                                          staticStyle: { "flex-grow": "1" },
                                        },
                                        [
                                          _c("v-skeleton-loader", {
                                            attrs: {
                                              type: "heading",
                                              width: "60%",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex flex-column align-end",
                                          staticStyle: {
                                            "margin-top": "auto",
                                            "padding-top": "8px",
                                          },
                                        },
                                        [
                                          _c("v-skeleton-loader", {
                                            staticClass: "mb-1",
                                            attrs: {
                                              type: "text",
                                              width: "30%",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("v-skeleton-loader", {
                                            attrs: {
                                              type: "text",
                                              width: "50%",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass: "pa-4 d-flex flex-column",
                                      staticStyle: {
                                        height: "100%",
                                        position: "relative",
                                        "padding-bottom": "20px",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-space-between align-start mb-1",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "text-uppercase font-weight-bold",
                                              staticStyle: {
                                                "font-size": "16px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("homeStats.players")
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                "data-testid":
                                                  "home-icon-players",
                                                color: _vm.$vuetify.theme.dark
                                                  ? "white"
                                                  : "black",
                                                size: "28",
                                              },
                                            },
                                            [_vm._v("directions_run")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "mb-4",
                                          staticStyle: { "flex-grow": "1" },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "font-weight-bold",
                                              staticStyle: {
                                                "font-size": "28px !important",
                                                "font-family":
                                                  "'PPFormula Semi Extended Bold', sans-serif !important",
                                                "text-transform": "none",
                                                "letter-spacing": "normal",
                                                "line-height": "1.2",
                                              },
                                              attrs: {
                                                "data-testid":
                                                  "home-value-players",
                                              },
                                            },
                                            [_vm._v(_vm._s(_vm.clientPlayers))]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-end align-start",
                                          staticStyle: {
                                            "margin-top": "auto",
                                            "padding-top": "8px",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex flex-column align-end",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex align-center",
                                                  staticStyle: {
                                                    "margin-bottom": "2px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "mr-1",
                                                      attrs: {
                                                        "data-testid":
                                                          "home-total-icon-players",
                                                        color: _vm.$vuetify
                                                          .theme.dark
                                                          ? "grey lighten-2"
                                                          : "grey",
                                                        size: "16",
                                                      },
                                                    },
                                                    [_vm._v("layers")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "body-2 font-weight-medium",
                                                      attrs: {
                                                        "data-testid":
                                                          "home-total-players",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.driblabStats.dP
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-2 grey--text text--darken-1",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "homeStats.totalPlayers"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { flex: "1 1 0", "min-width": "0" } },
                        [
                          _c(
                            "v-card",
                            {
                              staticClass: "stats-card d-flex flex-column",
                              staticStyle: {
                                "border-radius": "8px",
                                height: "100%",
                              },
                              attrs: {
                                "data-testid": "home-card-teams",
                                elevation: "0",
                                outlined: "",
                              },
                            },
                            [
                              _vm.loading || !_vm.driblabStats
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "pa-4 d-flex flex-column",
                                      staticStyle: { height: "100%" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-space-between align-start mb-4",
                                        },
                                        [
                                          _c("v-skeleton-loader", {
                                            attrs: {
                                              type: "text",
                                              width: "40%",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("v-skeleton-loader", {
                                            staticClass: "ma-0",
                                            attrs: {
                                              type: "avatar",
                                              size: "28",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "mb-4",
                                          staticStyle: { "flex-grow": "1" },
                                        },
                                        [
                                          _c("v-skeleton-loader", {
                                            attrs: {
                                              type: "heading",
                                              width: "60%",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex flex-column align-end",
                                          staticStyle: {
                                            "margin-top": "auto",
                                            "padding-top": "8px",
                                          },
                                        },
                                        [
                                          _c("v-skeleton-loader", {
                                            staticClass: "mb-1",
                                            attrs: {
                                              type: "text",
                                              width: "30%",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("v-skeleton-loader", {
                                            attrs: {
                                              type: "text",
                                              width: "50%",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass: "pa-4 d-flex flex-column",
                                      staticStyle: {
                                        height: "100%",
                                        position: "relative",
                                        "padding-bottom": "20px",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-space-between align-start mb-1",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "text-uppercase font-weight-bold",
                                              staticStyle: {
                                                "font-size": "16px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("homeStats.teams")
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                "data-testid":
                                                  "home-icon-teams",
                                                color: _vm.$vuetify.theme.dark
                                                  ? "white"
                                                  : "black",
                                                size: "28",
                                              },
                                            },
                                            [_vm._v("shield")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "mb-4",
                                          staticStyle: { "flex-grow": "1" },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "font-weight-bold",
                                              staticStyle: {
                                                "font-size": "28px !important",
                                                "font-family":
                                                  "'PPFormula Semi Extended Bold', sans-serif !important",
                                                "text-transform": "none",
                                                "letter-spacing": "normal",
                                                "line-height": "1.2",
                                              },
                                              attrs: {
                                                "data-testid":
                                                  "home-value-teams",
                                              },
                                            },
                                            [_vm._v(_vm._s(_vm.clientTeams))]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-end align-start",
                                          staticStyle: {
                                            "margin-top": "auto",
                                            "padding-top": "8px",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex flex-column align-end",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex align-center",
                                                  staticStyle: {
                                                    "margin-bottom": "2px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "mr-1",
                                                      attrs: {
                                                        "data-testid":
                                                          "home-total-icon-teams",
                                                        color: _vm.$vuetify
                                                          .theme.dark
                                                          ? "grey lighten-2"
                                                          : "grey",
                                                        size: "16",
                                                      },
                                                    },
                                                    [_vm._v("layers")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "body-2 font-weight-medium",
                                                      attrs: {
                                                        "data-testid":
                                                          "home-total-teams",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.driblabStats.dT
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-2 grey--text text--darken-1",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "homeStats.totalTeams"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { flex: "1 1 0", "min-width": "0" } },
                        [
                          _c(
                            "v-card",
                            {
                              staticClass: "stats-card d-flex flex-column",
                              staticStyle: {
                                "border-radius": "8px",
                                height: "100%",
                              },
                              attrs: {
                                "data-testid": "home-card-leagues",
                                elevation: "0",
                                outlined: "",
                              },
                            },
                            [
                              _vm.loading || !_vm.driblabStats
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "pa-4 d-flex flex-column",
                                      staticStyle: { height: "100%" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-space-between align-start mb-4",
                                        },
                                        [
                                          _c("v-skeleton-loader", {
                                            attrs: {
                                              type: "text",
                                              width: "40%",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("v-skeleton-loader", {
                                            staticClass: "ma-0",
                                            attrs: {
                                              type: "avatar",
                                              size: "28",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "mb-4",
                                          staticStyle: { "flex-grow": "1" },
                                        },
                                        [
                                          _c("v-skeleton-loader", {
                                            attrs: {
                                              type: "heading",
                                              width: "60%",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex flex-column align-end",
                                          staticStyle: {
                                            "margin-top": "auto",
                                            "padding-top": "8px",
                                          },
                                        },
                                        [
                                          _c("v-skeleton-loader", {
                                            staticClass: "mb-1",
                                            attrs: {
                                              type: "text",
                                              width: "30%",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("v-skeleton-loader", {
                                            attrs: {
                                              type: "text",
                                              width: "50%",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass: "pa-4 d-flex flex-column",
                                      staticStyle: {
                                        height: "100%",
                                        position: "relative",
                                        "padding-bottom": "20px",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-space-between align-start mb-1",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "text-uppercase font-weight-bold",
                                              staticStyle: {
                                                "font-size": "16px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("homeStats.leagues")
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                "data-testid":
                                                  "home-icon-leagues",
                                                color: _vm.$vuetify.theme.dark
                                                  ? "white"
                                                  : "black",
                                                size: "28",
                                              },
                                            },
                                            [_vm._v("emoji_events")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "mb-4",
                                          staticStyle: { "flex-grow": "1" },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "font-weight-bold",
                                              staticStyle: {
                                                "font-size": "28px !important",
                                                "font-family":
                                                  "'PPFormula Semi Extended Bold', sans-serif !important",
                                                "text-transform": "none",
                                                "letter-spacing": "normal",
                                                "line-height": "1.2",
                                              },
                                              attrs: {
                                                "data-testid":
                                                  "home-value-leagues",
                                              },
                                            },
                                            [_vm._v(_vm._s(_vm.clientLeagues))]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-end align-start",
                                          staticStyle: {
                                            "margin-top": "auto",
                                            "padding-top": "8px",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex flex-column align-end",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex align-center",
                                                  staticStyle: {
                                                    "margin-bottom": "2px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "mr-1",
                                                      attrs: {
                                                        "data-testid":
                                                          "home-total-icon-leagues",
                                                        color: _vm.$vuetify
                                                          .theme.dark
                                                          ? "grey lighten-2"
                                                          : "grey",
                                                        size: "16",
                                                      },
                                                    },
                                                    [_vm._v("layers")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "body-2 font-weight-medium",
                                                      attrs: {
                                                        "data-testid":
                                                          "home-total-leagues",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.driblabStats.dL
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-2 grey--text text--darken-1",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "homeStats.totalLeagues"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { flex: "1 1 0", "min-width": "0" } },
                        [
                          _c(
                            "v-card",
                            {
                              staticClass: "stats-card d-flex flex-column",
                              staticStyle: {
                                "border-radius": "8px",
                                height: "100%",
                              },
                              attrs: {
                                "data-testid": "home-card-seasons",
                                elevation: "0",
                                outlined: "",
                              },
                            },
                            [
                              _vm.loading || !_vm.driblabStats
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "pa-4 d-flex flex-column",
                                      staticStyle: { height: "100%" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-space-between align-start mb-4",
                                        },
                                        [
                                          _c("v-skeleton-loader", {
                                            attrs: {
                                              type: "text",
                                              width: "40%",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("v-skeleton-loader", {
                                            staticClass: "ma-0",
                                            attrs: {
                                              type: "avatar",
                                              size: "28",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "mb-4",
                                          staticStyle: { "flex-grow": "1" },
                                        },
                                        [
                                          _c("v-skeleton-loader", {
                                            attrs: {
                                              type: "heading",
                                              width: "60%",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex flex-column align-end",
                                          staticStyle: {
                                            "margin-top": "auto",
                                            "padding-top": "8px",
                                          },
                                        },
                                        [
                                          _c("v-skeleton-loader", {
                                            staticClass: "mb-1",
                                            attrs: {
                                              type: "text",
                                              width: "30%",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("v-skeleton-loader", {
                                            attrs: {
                                              type: "text",
                                              width: "50%",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass: "pa-4 d-flex flex-column",
                                      staticStyle: {
                                        height: "100%",
                                        position: "relative",
                                        "padding-bottom": "20px",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-space-between align-start mb-1",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "text-uppercase font-weight-bold",
                                              staticStyle: {
                                                "font-size": "16px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("homeStats.seasons")
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                "data-testid":
                                                  "home-icon-seasons",
                                                color: _vm.$vuetify.theme.dark
                                                  ? "white"
                                                  : "black",
                                                size: "28",
                                              },
                                            },
                                            [_vm._v("event")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "mb-4",
                                          staticStyle: { "flex-grow": "1" },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "font-weight-bold",
                                              staticStyle: {
                                                "font-size": "28px !important",
                                                "font-family":
                                                  "'PPFormula Semi Extended Bold', sans-serif !important",
                                                "text-transform": "none",
                                                "letter-spacing": "normal",
                                                "line-height": "1.2",
                                              },
                                              attrs: {
                                                "data-testid":
                                                  "home-value-seasons",
                                              },
                                            },
                                            [_vm._v(_vm._s(_vm.clientSeasons))]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-end align-start",
                                          staticStyle: {
                                            "margin-top": "auto",
                                            "padding-top": "8px",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex flex-column align-end",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex align-center",
                                                  staticStyle: {
                                                    "margin-bottom": "2px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "mr-1",
                                                      attrs: {
                                                        "data-testid":
                                                          "home-total-icon-seasons",
                                                        color: _vm.$vuetify
                                                          .theme.dark
                                                          ? "grey lighten-2"
                                                          : "grey",
                                                        size: "16",
                                                      },
                                                    },
                                                    [_vm._v("layers")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "body-2 font-weight-medium",
                                                      attrs: {
                                                        "data-testid":
                                                          "home-total-seasons",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.driblabStats.dS
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-2 grey--text text--darken-1",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "homeStats.totalSeasons"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { flex: "1 1 0", "min-width": "0" } },
                        [
                          _c(
                            "v-card",
                            {
                              staticClass: "stats-card d-flex flex-column",
                              staticStyle: {
                                "border-radius": "8px",
                                height: "100%",
                              },
                              attrs: {
                                "data-testid": "home-card-games",
                                elevation: "0",
                                outlined: "",
                              },
                            },
                            [
                              _vm.loading || !_vm.driblabStats
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "pa-4 d-flex flex-column",
                                      staticStyle: { height: "100%" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-space-between align-start mb-4",
                                        },
                                        [
                                          _c("v-skeleton-loader", {
                                            attrs: {
                                              type: "text",
                                              width: "40%",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("v-skeleton-loader", {
                                            staticClass: "ma-0",
                                            attrs: {
                                              type: "avatar",
                                              size: "28",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "mb-4",
                                          staticStyle: { "flex-grow": "1" },
                                        },
                                        [
                                          _c("v-skeleton-loader", {
                                            attrs: {
                                              type: "heading",
                                              width: "60%",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex flex-column align-end",
                                          staticStyle: {
                                            "margin-top": "auto",
                                            "padding-top": "8px",
                                          },
                                        },
                                        [
                                          _c("v-skeleton-loader", {
                                            staticClass: "mb-1",
                                            attrs: {
                                              type: "text",
                                              width: "30%",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("v-skeleton-loader", {
                                            attrs: {
                                              type: "text",
                                              width: "50%",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass: "pa-4 d-flex flex-column",
                                      staticStyle: {
                                        height: "100%",
                                        position: "relative",
                                        "padding-bottom": "20px",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-space-between align-start mb-1",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "text-uppercase font-weight-bold",
                                              staticStyle: {
                                                "font-size": "16px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("homeStats.games")
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                "data-testid":
                                                  "home-icon-games",
                                                color: _vm.$vuetify.theme.dark
                                                  ? "white"
                                                  : "black",
                                                size: "28",
                                              },
                                            },
                                            [_vm._v("sports_soccer")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "mb-4",
                                          staticStyle: { "flex-grow": "1" },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "font-weight-bold",
                                              staticStyle: {
                                                "font-size": "28px !important",
                                                "font-family":
                                                  "'PPFormula Semi Extended Bold', sans-serif !important",
                                                "text-transform": "none",
                                                "letter-spacing": "normal",
                                                "line-height": "1.2",
                                              },
                                              attrs: {
                                                "data-testid":
                                                  "home-value-games",
                                              },
                                            },
                                            [_vm._v(_vm._s(_vm.clientGames))]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-end align-start",
                                          staticStyle: {
                                            "margin-top": "auto",
                                            "padding-top": "8px",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex flex-column align-end",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex align-center",
                                                  staticStyle: {
                                                    "margin-bottom": "2px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "mr-1",
                                                      attrs: {
                                                        "data-testid":
                                                          "home-total-icon-games",
                                                        color: _vm.$vuetify
                                                          .theme.dark
                                                          ? "grey lighten-2"
                                                          : "grey",
                                                        size: "16",
                                                      },
                                                    },
                                                    [_vm._v("layers")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "body-2 font-weight-medium",
                                                      attrs: {
                                                        "data-testid":
                                                          "home-total-games",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.driblabStats.dG
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-2 grey--text text--darken-1",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "homeStats.totalGames"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$vuetify.breakpoint.smAndDown
                ? _c(
                    "v-card",
                    {
                      staticClass: "mb-0",
                      staticStyle: { "border-radius": "8px" },
                      attrs: { elevation: "1" },
                    },
                    [
                      _vm.loading || !_vm.driblabStats
                        ? _c(
                            "v-card-text",
                            { staticClass: "pa-3" },
                            [
                              _c("v-skeleton-loader", {
                                staticClass: "mb-2",
                                attrs: { type: "list-item-avatar-three-line" },
                              }),
                              _vm._v(" "),
                              _c("v-skeleton-loader", {
                                staticClass: "mb-2",
                                attrs: { type: "list-item-avatar-three-line" },
                              }),
                              _vm._v(" "),
                              _c("v-skeleton-loader", {
                                attrs: { type: "list-item-avatar-three-line" },
                              }),
                            ],
                            1
                          )
                        : _c("v-card-text", { staticClass: "pa-0" }, [
                            _c(
                              "div",
                              {
                                staticClass: "d-flex align-center pa-3",
                                staticStyle: {
                                  "border-bottom": "1px solid rgba(0,0,0,0.12)",
                                },
                                attrs: { "data-testid": "home-mobile-players" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex align-center justify-center mr-3",
                                    staticStyle: {
                                      width: "48px",
                                      height: "48px",
                                      "border-radius": "4px",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          color: _vm.$vuetify.theme.dark
                                            ? "white"
                                            : "black",
                                          size: "24",
                                        },
                                      },
                                      [_vm._v("directions_run")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex flex-column flex-grow-1",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "d-flex align-baseline" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "font-weight-bold body-1 mr-1 primary--text",
                                            staticStyle: {
                                              "font-size": "18px",
                                              "font-family":
                                                "'PPFormula Semi Extended Bold', sans-serif !important",
                                              opacity: "1 !important",
                                            },
                                            attrs: {
                                              "data-testid":
                                                "home-mobile-value-players",
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.clientPlayers))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "body-2 grey--text text--darken-1",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("homeStats.players")
                                                  .toLowerCase()
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "body-2 grey--text text--darken-1 mt-1",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.driblabStats.dP) +
                                            " total " +
                                            _vm._s(
                                              _vm
                                                .$t("homeStats.players")
                                                .toLowerCase()
                                            )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "d-flex align-center pa-3",
                                staticStyle: {
                                  "border-bottom": "1px solid rgba(0,0,0,0.12)",
                                },
                                attrs: { "data-testid": "home-mobile-teams" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex align-center justify-center mr-3",
                                    staticStyle: {
                                      width: "48px",
                                      height: "48px",
                                      "border-radius": "4px",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          color: _vm.$vuetify.theme.dark
                                            ? "white"
                                            : "black",
                                          size: "24",
                                        },
                                      },
                                      [_vm._v("shield")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex flex-column flex-grow-1",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "d-flex align-baseline" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "font-weight-bold body-1 mr-1 primary--text",
                                            staticStyle: {
                                              "font-size": "18px",
                                              "font-family":
                                                "'PPFormula Semi Extended Bold', sans-serif !important",
                                              opacity: "1 !important",
                                            },
                                            attrs: {
                                              "data-testid":
                                                "home-mobile-value-teams",
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.clientTeams))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "body-2 grey--text text--darken-1",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("homeStats.teams")
                                                  .toLowerCase()
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "body-2 grey--text text--darken-1 mt-1",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.driblabStats.dT) +
                                            " total " +
                                            _vm._s(
                                              _vm
                                                .$t("homeStats.teams")
                                                .toLowerCase()
                                            )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "d-flex align-center pa-3",
                                staticStyle: {
                                  "border-bottom": "1px solid rgba(0,0,0,0.12)",
                                },
                                attrs: { "data-testid": "home-mobile-leagues" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex align-center justify-center mr-3",
                                    staticStyle: {
                                      width: "48px",
                                      height: "48px",
                                      "border-radius": "4px",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          color: _vm.$vuetify.theme.dark
                                            ? "white"
                                            : "black",
                                          size: "24",
                                        },
                                      },
                                      [_vm._v("emoji_events")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex flex-column flex-grow-1",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "d-flex align-baseline" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "font-weight-bold body-1 mr-1 primary--text",
                                            staticStyle: {
                                              "font-size": "18px",
                                              "font-family":
                                                "'PPFormula Semi Extended Bold', sans-serif !important",
                                              opacity: "1 !important",
                                            },
                                            attrs: {
                                              "data-testid":
                                                "home-mobile-value-leagues",
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.clientLeagues))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "body-2 grey--text text--darken-1",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("homeStats.leagues")
                                                  .toLowerCase()
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "body-2 grey--text text--darken-1 mt-1",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.driblabStats.dL) +
                                            " total " +
                                            _vm._s(
                                              _vm
                                                .$t("homeStats.leagues")
                                                .toLowerCase()
                                            )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "d-flex align-center pa-3",
                                staticStyle: {
                                  "border-bottom": "1px solid rgba(0,0,0,0.12)",
                                },
                                attrs: { "data-testid": "home-mobile-seasons" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex align-center justify-center mr-3",
                                    staticStyle: {
                                      width: "48px",
                                      height: "48px",
                                      "border-radius": "4px",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          color: _vm.$vuetify.theme.dark
                                            ? "white"
                                            : "black",
                                          size: "24",
                                        },
                                      },
                                      [_vm._v("event")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex flex-column flex-grow-1",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "d-flex align-baseline" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "font-weight-bold body-1 mr-1 primary--text",
                                            staticStyle: {
                                              "font-size": "18px",
                                              "font-family":
                                                "'PPFormula Semi Extended Bold', sans-serif !important",
                                              opacity: "1 !important",
                                            },
                                            attrs: {
                                              "data-testid":
                                                "home-mobile-value-seasons",
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.clientSeasons))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "body-2 grey--text text--darken-1",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("homeStats.seasons")
                                                  .toLowerCase()
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "body-2 grey--text text--darken-1 mt-1",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.driblabStats.dS) +
                                            " total " +
                                            _vm._s(
                                              _vm
                                                .$t("homeStats.seasons")
                                                .toLowerCase()
                                            )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "d-flex align-center pa-3",
                                attrs: { "data-testid": "home-mobile-games" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex align-center justify-center mr-3",
                                    staticStyle: {
                                      width: "48px",
                                      height: "48px",
                                      "border-radius": "4px",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          color: _vm.$vuetify.theme.dark
                                            ? "white"
                                            : "black",
                                          size: "24",
                                        },
                                      },
                                      [_vm._v("sports_soccer")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex flex-column flex-grow-1",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "d-flex align-baseline" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "font-weight-bold body-1 mr-1 primary--text",
                                            staticStyle: {
                                              "font-size": "18px",
                                              "font-family":
                                                "'PPFormula Semi Extended Bold', sans-serif !important",
                                              opacity: "1 !important",
                                            },
                                            attrs: {
                                              "data-testid":
                                                "home-mobile-value-games",
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.clientGames))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "body-2 grey--text text--darken-1",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("homeStats.games")
                                                  .toLowerCase()
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "body-2 grey--text text--darken-1 mt-1",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.driblabStats.dG) +
                                            " total " +
                                            _vm._s(
                                              _vm
                                                .$t("homeStats.games")
                                                .toLowerCase()
                                            )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        [
          _vm.currentUser.clientType != "Driblab" &&
          _vm.currentUser.clientType != "Media"
            ? _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _vm.currentUser.userType === "Scout"
                    ? _c("ScoutDashboard")
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentUser.userType === "Coach"
                    ? _c("CoachDashboard")
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentUser.userType === "Ownership"
                    ? _c("OwnerDashboard")
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentUser.userType === "SportingDirector"
                    ? _c("SportingDirectorDashboard")
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentUser.userType === "Individual"
                    ? _c("IndividualDashboard")
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentUser.userType === "Brand"
                    ? _c("BrandDashboard")
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentUser.userType === "Agency"
                    ? _c("AgencyDashboard")
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentUser.userType === "Federation"
                    ? _c("FederationDashboard")
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.currentUser.clientType === "Media"
            ? _c(
                "v-col",
                { attrs: { cols: "12" } },
                [_c("IndividualDashboard")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.currentUser.clientType === "Driblab"
            ? _c(
                "v-col",
                { attrs: { cols: "12" } },
                [_c("DriblabDashboard")],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }